import { getTitleThemeColor } from '../../../templates.js';
import { lightenHexColor } from '../../../utils/richText.js';

/** 双行标题组件共用逻辑（单色控制主色，副标题自动变浅） */
export const dualTitleMixin = {
	props: {
		data: {
			type: Object,
			required: true,
		},
		editable: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		h5: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['select', 'update'],
	computed: {
		themeColor() {
			return getTitleThemeColor(this.data);
		},
		lightColor() {
			return lightenHexColor(this.themeColor);
		},
	},
	methods: {
		onWrapClick(e) {
			if (!this.editable) return;
			e?.stopPropagation?.();
			this.$emit('select');
		},
		onPrimaryUpdate(primaryText) {
			this.$emit('update', { primaryText });
		},
		onSecondaryUpdate(secondaryText) {
			this.$emit('update', { secondaryText });
		},
	},
};
